// Pure predicates for BenefitRedeemCard's visual states, kept out of the
// .tsx so they can be unit tested from root vitest (which can't resolve
// React from a .tsx transitive import on CI).

type PinkLockedBenefit = {
  type: string;
  isWelcomeReward: boolean;
  periodLength?: string;
  tier?: { name: string };
};

// Love Inn Members' monthly free drink ("Free Local Pint") turns pink once
// already redeemed this period, so it stands out from other locked
// benefits. Matched structurally (not on description text, which reads
// differently prod vs staging, and not on benefit id, which differs per
// environment) so it survives copy edits and works in both environments.
export function shouldPinkLockedIcon(benefit: PinkLockedBenefit, venueSlug?: string): boolean {
  return (
    venueSlug === "love-inn" &&
    benefit.type === "FREE_DRINK" &&
    !benefit.isWelcomeReward &&
    benefit.periodLength === "MONTHLY" &&
    benefit.tier?.name === "Member"
  );
}
